export const iconFontAwesomeCommunicationMicrophoneLinesSlash = (
	<i className="fa-solid fa-microphone-lines-slash"></i>
);
